import {Component, EventEmitter, OnInit, Output} from '@angular/core';


@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {
  //public userPhoto = 'assets/img/avatars/user-thumbnail.gif';
  @Output() toggleSideNav: EventEmitter<any> = new EventEmitter();
  constructor() { }
  signOut() {

  }
  ngOnInit() {

  }
  toggle() {
    this.toggleSideNav.emit(null);
  }

}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/components/app-header/app-header.component.ts